import { LoadingIndicator, Spinner } from "@abb/abb-common-ux-react";
import React from "react";

interface IProps { }
interface IState { }

export default class SharedLoadingIndicator extends React.Component<IProps, IState> {
    public render() {
        return (
            <div style={{
                background: 'black',
                width: "100%",
                height: "100vh",
                position: "fixed",
                zIndex: 11111,
                opacity: 0.6
            }}>
                <div style={{ top: '42vh', left: '45vw', position: 'absolute' }}>
                    <LoadingIndicator
                        determinate={false}
                        type="radial"
                        color="blue"
                        sizeClass="large"
                    /></div>
            </div>
        )
    }
}